import { Component, OnInit, OnDestroy } from '@angular/core';
import { UiService } from '../../services/ui/ui.service';
import { UserService } from '../../services/user/user.service';
import { HelperService } from '../../services/helper/helper.service';

import { environment } from '../../../environments/environment';
import { Router, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {

  private _subscriptions: Subscription[] = [];
  private _previousSearchTerm = '';

  public searchTerm = '';
  public logo = '../assets/img/logo.png';
  public logoTemp = '../assets/img/logo.png';

  constructor(
    private ui: UiService,
    public user: UserService,
    public helper: HelperService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.getLogo().then(value => {
      if (value) {
        // Check the initial route on load
        const currentUrl = this.router.url;
        this.updateLogoBasedOnRoute(currentUrl);

        this._subscriptions.push(
          this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
              console.log('Current route:', event.url);

              if (!event.url.includes('search')) {
                this.searchTerm = '';
              }

              this.updateLogoBasedOnRoute(event.url);
            }
          }),
          this.router.routerState.root.queryParams.subscribe(queryParams => {
            this.searchTerm = queryParams.term || this.searchTerm;
            this._previousSearchTerm = this.searchTerm;
          })
        );
      }
    });
  }

  getLogo() {
    return new Promise((resolve, reject) => {
      const branchId = this.user.userBranchId;

      this.user.getLogo(branchId, (res) => {
        this.logoTemp = this.user.logoUrl || this.logo;
        resolve(this.logoTemp);
      });
    })
  }

  private updateLogoBasedOnRoute(url: string) {
    if (url.startsWith('/programme/6')) {
      this.logo = '../../../assets/img/BMI_UCL_Louvain_3logo2.jpg';
    } else {
      this.logo = this.logoTemp;
    }
  }

  ngOnDestroy() {
    this._subscriptions.forEach(S => S.unsubscribe());
  }

  toggleSidebar() {
    this.ui.showSidebar = !this.ui.showSidebar;
  }

  search() {
    if (this._previousSearchTerm === this.searchTerm) { return; }
    if (this.searchTerm) {
      this._previousSearchTerm = this.searchTerm;
      this.router.navigate(['/search'], { queryParams: { term: this.searchTerm } });
    }
  }

}



// WEBPACK FOOTER //
// G:/UTL/BMI/Admin/Admin-ANG/src/app/shared/header/header.component.ts